<template>
  <div>
    <div>
      <div class="searchArea">
        <!-- <a-range-picker v-model:value="inputs.patroltime" :placeholder="['应巡开始时间','应巡结束时间']" :locale="locale" /> -->
        <a-input v-model:value="inputs.name" placeholder="名称" />
        <a-select v-model:value="inputs.gender" placeholder="性别" allowClear>
          <a-select-option value="男">男</a-select-option>
          <a-select-option value="女">女</a-select-option>
        </a-select>
        <a-select v-model:value="inputs.isStandard" placeholder="标准化" allowClear>
          <a-select-option :value="true">标准化</a-select-option>
          <a-select-option :value="false">非标准化</a-select-option>
        </a-select>

        <a-button type="primary" shape="circle" @click="search('')">
          <template #icon>
            <SearchOutlined />
          </template>
        </a-button>
        <a-button style="margin-left: 10px" @click="resetForm">重置</a-button>
        <a-button style="margin-left: 10px" type="primary" @click="visible = true">
          <template #icon>
            <PlusOutlined />
          </template>
          新增症候
        </a-button>
      </div>

      <a-table class="ant-table-striped" :columns="columns" :data-source="data"
        :rowClassName="(record, index) => (index % 2 === 1 ? 'table-striped' : null)" bordered rowKey="id"
        :pagination="{ pageSize: $store.state.tableSize, total, current }" @change="search">

        <template #operation="{ record }">
          <!-- 操作列分槽对齐：每个按钮固定宽度占一槽，不显示的按钮留等宽空位 -->
          <div class="op-row">
            <div class="op-cell op-detail">
              <span>
                <a @click="Detail(record)">详情</a>
              </span>
            </div>
            <div class="op-cell op-link">
              <span>
                <a v-if="!record.isStandard" @click="linkSyndrome(record)">关联标准症候</a>
              </span>
            </div>
            <div class="op-cell op-toggle">
              <span v-if="!editableData[record.id]">
                <a-popconfirm v-if="record.isStandard" title="是否确认取消标准化" @confirm="changeIsStandard(record)" okText="确认"
                  cancelText="取消">
                  <a class="table_btn">非标准化</a>
                </a-popconfirm>
                <a-popconfirm v-if="!record.isStandard" title="是否确认标准化" @confirm="changeIsStandard(record)" okText="确认"
                  cancelText="取消">
                  <a class="table_btn">标准化</a>
                </a-popconfirm>
              </span>
            </div>
            <div class="op-cell op-edit">
              <span v-if="editableData[record.id]">
                <a @click="save(record.id)">保存</a>
              </span>
              <span v-if="editableData[record.id]">
                <a @click="cancel(record.id)">取消</a>
              </span>
              <span v-else>
                <a @click="edit(record.id)">编辑</a>
              </span>
            </div>
            <div class="op-cell op-del">
              <span v-if="!record.isStandard">
                <a-popconfirm v-if="data.length" title="是否确认删除" @confirm="onDelete(record.id)" okText="确认"
                  cancelText="取消">
                  <a>删除</a>
                </a-popconfirm>
              </span>
            </div>
          </div>
        </template>
        
        <template v-for="col in ['nameInitial']" #[col]="{ text, record }" :key="col">
          <div>
            <a-input v-if="editableData[record.id]" v-model:value="editableData[record.id][col]"
              style="margin: -5px 0" />
            <template v-else>{{ text }}</template>
          </div>
        </template>
        
        <template v-for="col in ['name']" #[col]="{ text, record }" :key="col">
          <div>
            <a-input v-if="editableData[record.id]" v-model:value="editableData[record.id][col]"
              @change="changeDataNameInitial(record)" style="margin: -5px 0" />
            <template v-else>{{ text }}</template>
          </div>
        </template>
        
        <template v-for="col in ['gender']" #[col]="{ text, record }" :key="col">
          <div>
            <a-select v-if="editableData[record.id]" v-model:value="editableData[record.id][col]" placeholder="性别"
              allowClear style="width:80px;text-align: center;">
              <a-select-option value="">不限</a-select-option>
              <a-select-option value="男">男</a-select-option>
              <a-select-option value="女">女</a-select-option>
            </a-select>
            <template v-else>{{ text }}</template>
          </div>
        </template>
        
        <template v-for="col in ['isStandard']" #[col]="{ text, record }" :key="col">
          <div>
            <div v-if="text">
              <check-circle-filled style="color:#389e0d;font-size:20px" />
            </div>
            <div v-else>
              <warning-filled style="color:#d4380d;font-size:20px" />
            </div>
          </div>
        </template>
        
        <template v-for="col in ['drugPair']" #[col]="{ column, text, record }" :key="col">
          <div @click="getAutoPrescription(record, col)" class="clickable">
            {{ record["drugPair"] }}
            <form-outlined style="color:#40a9ff;cursor: pointer;" />
          </div>
        </template>
        
        <template v-for="col in ['syndromeAcupoints']" #[col]="{ column, text, record }" :key="col">
          <div @click="getAutoPrescription(record, col)" class="clickable">
            {{ record["syndromeAcupoints"] }}
            <form-outlined style="color:#40a9ff;cursor: pointer;" />
          </div>
        </template>
      </a-table>
    </div>

    <addSyndrome v-model="visible" />
    <getAutoPrescription v-model="visible2" :record="selectedRow" />
    <linkSyndrome v-model="visible3" :record="selectedRow" @reload="search({ current })" />
    <getSyndrome v-model="visible4" :record="selectedRow" />

  </div>
</template>

<style scoped>
.online {
  background: #40a9ff;
  border-color: #40a9ff;
}

.offline {
  background: #979596;
  border-color: #979596;
}

.clickable {
  cursor: pointer;
}

:deep(.ant-table-tbody > tr > td, .ant-table-thead > tr > th) {
  padding: 10px 8px;
}

/* 操作列：按钮按百分比分槽，隐藏的按钮用等宽空位占位，保证各行上下对齐。
   槽宽 = 操作列宽度的百分比；min-width 是兜底，列被压窄时低于它就不再缩，防止文字挤爆 */
.op-row {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}

.op-cell {
  flex: none;
  white-space: nowrap;
  text-align: center;
}

.op-detail { width: 11%; min-width: 28px; }   /* 详情 */
.op-link   { width: 34%; min-width: 84px; }   /* 关联标准症候 */
.op-toggle { width: 25%; min-width: 58px; }   /* 标准化 / 非标准化 */
.op-edit   { width: 16%; min-width: 30px; }   /* 编辑 / 保存+取消 */
.op-del    { width: 14%; min-width: 28px; }   /* 删除（标准化行为空位） */

/* 槽宽是百分比，而 .table_btn 宽度自适应，宽列里会留大缝——让它填满自己的槽并居中 */
.op-toggle .table_btn {
  display: inline-block;
  width: 100%;
  text-align: center;
}
</style>

<script>
import {
  SearchOutlined,
  PlusOutlined,
  CheckCircleFilled,
  WarningFilled,
  FormOutlined
} from "@ant-design/icons-vue";
// import { reactive } from "vue"; // 修复：由于使用了 Options API (data)，不需要 reactive
import { cloneDeep } from "lodash-es";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import { Search, Update, Delete } from "/src/api/syndrome.js";
import addSyndrome from '/src/components/syndrome/addSyndrome.vue';
import linkSyndrome from '/src/components/syndrome/linkSyndrome.vue';
import getSyndrome from '/src/components/syndrome/getSyndrome.vue';
import getAutoPrescription from '/src/components/autoPrescription/getAutoPrescription.vue';

export default {
  components: {
    SearchOutlined,
    PlusOutlined,
    locale,
    CheckCircleFilled,
    WarningFilled,
    addSyndrome,
    FormOutlined,
    getAutoPrescription,
    linkSyndrome,
    getSyndrome
  },
  name: "症候群管理",
  data() {
    return {
      modalBtn: "",
      modalIndex: "0",
      pageSize: "12",
      visible: false,
      visible3: false,
      visible4: false,
      visible2: false,
      active: undefined,
      id: undefined,
      total: 0,
      current: 1,
      inputs: {
        name: undefined,
      },
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 14,
      },
      columns: [
        {
          title: "名称",
          key: "name",
          dataIndex: "name",
          width: "10%",
          slots: { customRender: "name" }
        },
        {
          title: "首字母",
          key: "nameInitial",
          dataIndex: "nameInitial",
          ellipsis: true,
          width: "7.5%",
          slots: { customRender: "nameInitial" },
        },
        {
          title: "性别",
          width: "5%",
          key: "gender",
          dataIndex: "gender",
          slots: { customRender: "gender" }
        },
        {
          title: "药对",
          key: "drugPair",
          dataIndex: "drugPair",
          width: "10%",
          slots: { customRender: "drugPair" }
        },
        {
          title: "症候穴位处方",
          key: "syndromeAcupoints",
          dataIndex: "syndromeAcupoints",
          width: "10%",
          slots: { customRender: "syndromeAcupoints" }
        },
        {
          title: "标准化",
          key: "isStandard",
          dataIndex: "isStandard",
          width: "4%",
          slots: { customRender: "isStandard" }
        },
        {
          title: "操作",
          dataIndex: "operation",
          width: "15%",
          slots: { customRender: "operation" }
        }
      ],
      data: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          console.log(`selectedRowKeys: ${selectedRowKeys}`, "selectedRows: ", selectedRows);
          this.selectedRows = selectedRows;
        },
        onSelect: (record, selected, selectedRows) => {
          console.log(record, selected, selectedRows);
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          console.log(selected, selectedRows, changeRows);
        }
      },
      editableData: {}, 
      selectedRows: [],
      selectedRow: {}, 
    };
  },
  created() { },
  mounted() {
    this.search("");
  },
  activated() { },
  methods: {
    // 获取详情
    getPrescription(record) {
      this.visible = true;
      this.selectedRow = { ...record };
    },
    linkSyndrome(record) {
      this.visible3 = true;
      this.selectedRow = { ...record };
    },
    Detail(record) {
      this.visible4 = true;
      this.selectedRow = { ...record };
    },
    getAutoPrescription(record, col) {
      this.visible2 = true;
      this.selectedRow = { ...record, category: col };
    },
    resetForm() {
      this.inputs = {
        name: undefined,
      };
    },
    async onDelete(id) {
      this.editableData = {};
      let res = await Delete({ id });
      if (res.errCode == 0) {
        this.data = this.data.filter(function (item) {
          return item.id !== id;
        });
      } else {
        this.$message.error("删除失败", function () { });
      }
    },
    edit(id) {
      let _data = this.data;
      this.editableData[id] = cloneDeep(
        _data.filter(item => id === item.id)[0]
      );
    },
    async save(id) {
      let _data = this.data;
      //判断editableData和修改前是否一致，如果一致则不修改
      if (JSON.stringify(this.data.find((item) => item.id == id)) === JSON.stringify(this.editableData[id])) {
        delete this.editableData[id];
        return;
      }
      let res = await Update(this.editableData[id]);
      if (res.errCode == 0) {
        Object.assign(
          _data.filter(item => id === item.id)[0],
          this.editableData[id]
        );
        delete this.editableData[id];
      }
    },
    cancel(id) {
      delete this.editableData[id];
    },
    tabsName(tabName) {
      this.$store.commit("changePage", { name: tabName.name, query: tabName.query });
    },
    async search(pagination) {
      let _this = this;
      this.editableData = {};
      let params = {
        name: this.inputs.name,
        nameInitial: this.inputs.nameInitial,
        gender: this.inputs.gender,
        isStandard: this.inputs.isStandard,
        pageSize: this.pageSize,
        includeAi: true
      };
      if (pagination == "") {
        params.current = 1;
      } else {
        params.current = pagination.current;
        this.current = pagination.current;
      }
      let res = await Search(params);
      if (res.errCode == 0) {
        if (pagination == "") {
          this.current = 1;
        }
        this.total = res.data.total;
        this.data = res.data.records;
      } else {
        this.$message.error("查询失败", function () { });
      }
    },
    async changeIsStandard(record) {
      let res = await Update({ id: record.id, isStandard: !record.isStandard });
      if (res.errCode == 0) {
        record.isStandard = !record.isStandard;
        this.$store.dispatch('getSyndromeList');
      } else {
        this.$message.error("操作失败", function () { });
      }
    },
    changeDataNameInitial(record) {
    }
  }
};
</script>